import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const UserRelationshipSchema = withDefaults({
  type: 'user-relationship',
  objectExtensions: ['user-relationship'],
  fields: [
    {
      kind: 'attribute',
      name: 'relationshipType',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'belongsTo',
      name: 'role',
      type: 'user-role',
      options: {
        async: false,
        inverse: 'relationships',
      },
    },
    {
      kind: 'belongsTo',
      name: 'jurisdiction',
      type: 'user-role',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default UserRelationshipSchema;
